import { frontendURL } from '../../../../helper/URLHelper';
import SettingsContent from '../Wrapper.vue';const Index = () => import('./Index.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/status'),
      roles: ['administrator'],
      component: SettingsContent,
      props: {
        headerTitle: 'GENERAL_SETTINGS.STATUS.TITLE',
        icon: 'emoji',
        showNewButton: false,
      },
      children: [
        {
          path: '',
          name: 'status',
          component: Index,
          roles: ['administrator'],
        },
      ],
    },
  ],
};